import SectionsInShowcase from '../sectionsInShowcase'

export type ShowcaseProps = {
  isPreview?: boolean
}

const Showcase = ({ isPreview }: ShowcaseProps) => {
  return <SectionsInShowcase isPreview={isPreview} />
}

export default Showcase
